
import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Product } from "@/types/services";

interface AddProductButtonProps {
  onClick: () => void;
}

export const AddProductButton = ({ onClick }: AddProductButtonProps) => {
  return (
    <div className="flex justify-center mt-8">
      <Button
        type="button"
        variant="outline"
        size="lg"
        className="flex items-center gap-2 border-dashed border-2 hover:bg-pink-50"
        onClick={onClick}
      >
        <Plus className="h-5 w-5 text-gebeya-pink" />
        <span>Add Another Service</span>
      </Button>
    </div>
  );
};
